import { render } from "./ChartChangeAlert.vue?vue&type=template&id=640cf4d4"
import script from "./ChartChangeAlert.vue?vue&type=script&lang=js"
export * from "./ChartChangeAlert.vue?vue&type=script&lang=js"

import "./ChartChangeAlert.vue?vue&type=style&index=0&id=640cf4d4&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__